export enum CustomFormMessages {
  formFrameHost = 'CUSTOM_FORM_FRAME_HOST',
  formDimensionsChanged = 'FORM_DIMENSIONS_CHANGED',
  acknowledge = 'ACKNOWLEDGE',
}
